import React from "react";
import { Typography, Grid, Box, Paper, Button, Divider } from "@mui/material";

const DeberesYDerechos = ({ handleClose }) => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom textAlign="center" mt={2}>
        TUS DEBERES Y DERECHOS
      </Typography>
      <Divider sx={{ mb: 4 }} />
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, textAlign: "center", height: "100%" }}>
            <img
              src="../../assets/deberes.png"
              alt="Tus Deberes"
              width="100px"
            />
            <Typography variant="h5" fontWeight={"bold"} gutterBottom>
              TUS DEBERES
            </Typography>
            <Typography variant="body1" gutterBottom>
              1. Usa correctamente el servicio; cumple y respeta las
              obligaciones originadas por el uso del servicio.
            </Typography>
            <Typography variant="body1" gutterBottom>
              2. No hagas uso fraudulento del servicio.
            </Typography>
            <Typography variant="body1" gutterBottom>
              3. Paga puntualmente por el servicio que utilizas.
            </Typography>
            <Typography variant="body1" gutterBottom>
              4. Proporciona tus datos personales exigidos por Ley.
            </Typography>
            <Typography variant="body1" gutterBottom>
              5. No alteres los terminales, sistemas o redes de los Proveedores
              o de otros Usuarios.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, textAlign: "center", height: "100%" }}>
            <img
              src="../../assets/derechos.png"
              alt="Tus Derechos"
              width="100px"
            />
            <Typography variant="h5" fontWeight={"bold"} gutterBottom>
              TUS DERECHOS
            </Typography>
            <Typography variant="body1" gutterBottom>
              1. No ser discriminado al contratar un servicio.
            </Typography>
            <Typography variant="body1" gutterBottom>
              2. Recibir factura clara y detallada por tu consumo.
            </Typography>
            <Typography variant="body1" gutterBottom>
              3. Procedimientos fáciles y sencillos para interponer tus reclamos
              y denuncias.
            </Typography>
            <Typography variant="body1" gutterBottom>
              4. Trato preferencial para adultos mayores y personas con
              capacidades especiales.
            </Typography>
            <Typography variant="body1" gutterBottom>
              5. Elegir y cambiar de Proveedor, conservando tu número en
              Telefonía Móvil y Fija.
            </Typography>
            <Typography variant="body1" gutterBottom>
              6. Que el Proveedor respete las condiciones pactadas, sean
              técnicas, económicas o legales.
            </Typography>
            <Typography variant="body1" gutterBottom>
              7. Que la información y publicaciones sean reales y fáciles de
              consultar.
            </Typography>
            <Typography variant="body1" gutterBottom>
              8. Ser compensado en caso de interrupción del servicio.
            </Typography>
            <Typography variant="body1" gutterBottom>
              9. Protección de tus datos personales.
            </Typography>
            <Typography variant="body1" gutterBottom>
              10. Solicitar la desconexión o bloqueo de algunos servicios.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="center" mt={2}>
        <Button variant="contained" color="primary" onClick={handleClose}>
          CERRAR
        </Button>
      </Box>
    </Box>
  );
};

export default DeberesYDerechos;
